
import { defineComponent, PropType } from 'vue'

type Link = {
    id: number
    name: string
    to: string
}

export default defineComponent({
    name: 'new-breadcrumbs',
    props: {
        links: {
            type: Array as PropType<Link[]>,
            default: () => [],
        },
    },
})
